import { render } from "./Invest.vue?vue&type=template&id=2c3e6830&scoped=true"
import script from "./Invest.vue?vue&type=script&lang=js"
export * from "./Invest.vue?vue&type=script&lang=js"

import "./Invest.vue?vue&type=style&index=0&id=2c3e6830&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c3e6830"]])

export default __exports__